import { render, staticRenderFns } from "./addExtraFee.vue?vue&type=template&id=26714120&scoped=true&"
import script from "./addExtraFee.vue?vue&type=script&lang=js&"
export * from "./addExtraFee.vue?vue&type=script&lang=js&"
import style0 from "./addExtraFee.vue?vue&type=style&index=0&id=26714120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26714120",
  null
  
)

export default component.exports